export const NoMatchDataView = () => {
	return (
		<div className="flex min-h-[50vh] flex-col items-center justify-center p-4">
			<h2 className="mb-2 text-2xl font-semibold text-gray-700">No Match Data Available</h2>
			<p className="text-gray-500">The requested match information could not be found.</p>
		</div>
	);
};
